var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PlatformSettings } from '../../../../models/platform-settings/platform-settings';
import { UserService } from '../../../services/user.service';
import { AbstractAchooComponent } from '../../abstract-achoo.component';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { Location } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { ObjectUtils } from '../../../utils/object.utils';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { defaultPlatformSettings } from '../../../app.constants';
var PlatformSettingsComponent = /** @class */ (function (_super) {
    __extends(PlatformSettingsComponent, _super);
    function PlatformSettingsComponent(userService, location, campaignService, modalService) {
        var _this = _super.call(this, userService) || this;
        _this.userService = userService;
        _this.location = location;
        _this.campaignService = campaignService;
        _this.modalService = modalService;
        _this.env = environment;
        _this.currentSettings = new PlatformSettings();
        // TODO: change when sending domain can be customized
        _this.supportedDomains = [{ id: 0, name: '@Influencerprogram.com' }];
        return _this;
    }
    PlatformSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.userService.platformSettings.subscribe(function (setting) {
            _this.currentSettings = ObjectUtils.deepClone(setting);
            _this.uploadedLogoImage = setting.logoContent;
        });
    };
    PlatformSettingsComponent.prototype.onLogoImageSelected = function (evt) {
        if (!evt || !evt.target || !evt.target.files) {
            return;
        }
        var selectedImageList = (evt.target.files);
        if (!selectedImageList.length) {
            return;
        }
        this.uploadPlatformLogo(selectedImageList[0]);
    };
    PlatformSettingsComponent.prototype.onUploadLogoSuccess = function (evt) {
        this.uploadPlatformLogo(evt[0]);
    };
    PlatformSettingsComponent.prototype.uploadPlatformLogo = function (logo) {
        var _this = this;
        this.campaignService.validateMaterialUploadFile(logo);
        // Only upload one file on each select
        var formData = new FormData();
        formData.append('file', logo);
        this.campaignService.uploadFile(formData).subscribe(function (data) {
            if (data) {
                _this.currentSettings.logo = data.id;
                _this.uploadedLogoImage = data.diskFileName;
            }
        });
    };
    Object.defineProperty(PlatformSettingsComponent.prototype, "firstHalfPriorityColors", {
        get: function () {
            return this.currentSettings.chartColors.slice(0, 5);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "secondHalfPriorityColors", {
        get: function () {
            return this.currentSettings.chartColors.slice(5, 10);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "firstHalfBottombarColors", {
        get: function () {
            return this.currentSettings.bottombarButtonColors.slice(0, 2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "secondHalfBottombarColors", {
        get: function () {
            return this.currentSettings.bottombarButtonColors.slice(2, 4);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "firstHalfEmailButtonColors", {
        get: function () {
            return this.currentSettings.emailButtonColors.slice(0, 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "secondHalfEmailButtonColors", {
        get: function () {
            return this.currentSettings.emailButtonColors.slice(1, 2);
        },
        enumerable: true,
        configurable: true
    });
    PlatformSettingsComponent.prototype.updatePlatformSettings = function () {
        var _this = this;
        return this.userService.savePlatformSettings(this.companyId, this.currentSettings).subscribe(function (res) {
            _this.userService.loadPlatformSettingByCampanyId(_this.companyId);
            _this.modalService.open(_this.notificationSaveSuccess, undefined, true);
        });
    };
    PlatformSettingsComponent.prototype.resetAll = function () {
        this.currentSettings = ObjectUtils.deepClone(defaultPlatformSettings);
    };
    PlatformSettingsComponent.prototype.companyChangeCallback = function (companyId) {
        // callback when company change
    };
    Object.defineProperty(PlatformSettingsComponent.prototype, "logoImage", {
        get: function () {
            if (this.currentSettings.logo === 0 || this.currentSettings.logo == null) {
                return undefined;
            }
            else {
                return this.uploadedLogoImage;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "defaultChartColors", {
        get: function () {
            return defaultPlatformSettings.chartColors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "defaultPlatformColor", {
        get: function () {
            return defaultPlatformSettings.platformBgColor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "defaultBottombarButtonColors", {
        get: function () {
            return defaultPlatformSettings.bottombarButtonColors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "defaultBottombarBgColor", {
        get: function () {
            return defaultPlatformSettings.bottombarBgColor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "defaultEmailButtonColors", {
        get: function () {
            return defaultPlatformSettings.emailButtonColors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "defaultEmailBgColor", {
        get: function () {
            return defaultPlatformSettings.emailBgColor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformSettingsComponent.prototype, "isFreeUser", {
        get: function () {
            return this.userService.isFreeUser();
        },
        enumerable: true,
        configurable: true
    });
    PlatformSettingsComponent.prototype.trackColorChart = function (index, color) {
        return index;
    };
    return PlatformSettingsComponent;
}(AbstractAchooComponent));
export { PlatformSettingsComponent };



// WEBPACK FOOTER //
// ./src/app/main/admin/platform-settings/platform-settings.component.ts.pre-build-optimizer.js